import { pick } from "lodash";

export interface CSSRect {
  top?: string | number;
  right?: string | number;
  bottom?: string | number;
  left?: string | number;
}

const VALUE_WITH_UNIT_REGEX = /^-?\d+(px|em|%)$/;
const SIDES_REGEX = /^(\d+(px|%)?)\s*(\d+(px|%)?)?\s*(\d+(px|%)?)?\s*(\d+(px|%)?)?$/;
/**
 * parses padding/margin-like CSS value
 */
export const parseSides = (style: React.CSSProperties, propMask: string): CSSRect | undefined => {
  const name = propMask.replace("{0}", "");
  if (style[name]) {
    if (style[name].toString().match(VALUE_WITH_UNIT_REGEX)) {
      const v = style[name];
      return {
        bottom: v,
        left: v,
        right: v,
        top: v
      };
    }

    const match = style[name].toString().match(SIDES_REGEX);
    if (!match) return;

    return {
      bottom: match[5] || match[1],
      left: match[7] || match[3] || match[1],
      top: match[1],
      right: match[3] || match[1]
    };
  }
  const right = propMask.replace("{0}", "Right");
  const left = propMask.replace("{0}", "Left");
  const top = propMask.replace("{0}", "Top");
  const bottom = propMask.replace("{0}", "Bottom");
  if (!(right in style) && !(bottom in style) && !(left in style) && !(top in style)) return;

  return {
    right: style[right],
    left: style[left],
    bottom: style[bottom],
    top: style[top]
  };
};

export const parseBorderWidth = (style: React.CSSProperties): CSSRect | undefined =>
  parseSides(style, "border{0}Width");
export const parsePadding = (style: React.CSSProperties): CSSRect | undefined => parseSides(style, "padding{0}");
export const parseMargin = (style: React.CSSProperties): CSSRect | undefined => parseSides(style, "margin{0}");

const FONT_PROPERTIES_NAMES = [
  "fontFamily",
  "fontSize",
  "lineHeight",
  "letterSpacing",
  "fontWeight",
  "fontStyle",
  "color",
  "textDecoration",
  "textShadow",
  "textTransform"
];
export const pickFontValues = (style: React.CSSProperties): React.CSSProperties => pick(style, FONT_PROPERTIES_NAMES);
